import {
  ENTITY_ID_PREFIX,
  entityLoader,
  rootLoader,
} from '@oppy/omniv2-entity';
import { routes as iaRoutes } from '@oppy/omniv2-ia';
import { routes as rcsRoutes } from '@oppy/omniv2-rcs';
import * as Sentry from '@sentry/react';
import type { QueryClient } from '@tanstack/react-query';
import EnvironmentVariablePage from 'pages/environment-variable/environment-variable';
import ForbiddenPage from 'pages/forbidden';
import NotFoundPage from 'pages/not-found';
import { createBrowserRouter } from 'react-router-dom';

import MainLayout from '@/layouts/main-layout';

type Router = ReturnType<typeof createBrowserRouter>;

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export default function createRouter(queryClient: QueryClient): Router {
  return sentryCreateBrowserRouter([
    {
      path: '/',
      element: <MainLayout />,
      children: [
        { id: 'root', index: true, loader: rootLoader },
        { path: 'forbidden', element: <ForbiddenPage /> },
        {
          path: ENTITY_ID_PREFIX,
          loader: entityLoader(queryClient),
          children: [
            ...iaRoutes,
            ...(import.meta.env.VITE_RCS_ACTIVATION === 'true'
              ? rcsRoutes
              : []),
          ],
        },
      ],
      errorElement: <NotFoundPage />,
    },
    import.meta.env.VITE_APP_ENVIRONMENT !== 'production'
      ? {
          id: 'envs',
          path: 'envs',
          element: <EnvironmentVariablePage />,
        }
      : {},
  ]);
}
